import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { getProductCatUrl } from "../../helpers/url";
const CategoryFourSingle = ({ data, sliderClass, width, flipAnimation }) => {

  let btnStyle = {
    color: data.btnTextColor,
    backgroundColor: data.btnColor,
    border: 'none'
  }
  const globalParams = {
    sso_token: localStorage.getItem('sso-token'),
  }

  function extractParamsAndBaseUrl(url) {
    const urlObject = new URL(url);
    const baseUrl = `${urlObject.protocol}//${urlObject.host}${urlObject.pathname}`;

    const params = {};
    urlObject.searchParams.forEach((value, key) => {
      params[key] = value;
    });

    return { baseUrl, params };
  }

  const getLinkParams = (Link) => {
    let baseUrl = "", params = {};
    try {
      const paramsAndBaseUrl = extractParamsAndBaseUrl(Link);
      baseUrl = paramsAndBaseUrl.baseUrl;
      params = paramsAndBaseUrl.params;

      if (baseUrl && Object.keys(params).length > 0) {
        const newParams = {}
        Object.keys(params).forEach(key => {
          if (globalParams[key]) {
            newParams[key] = globalParams[key]
          }
        })
        if (Object.keys(newParams).length > 0) {
          Link = baseUrl + "?" + new URLSearchParams(newParams).toString()
        } else {
            Link = baseUrl
        }
      }
    } catch (e) {
    }
    return Link
  }

  return (
    <div className={`antera-category-slider-container collection-product ${sliderClass ? sliderClass : ""} items `}>
      {
        flipAnimation ?
          <div className="antera-category-slider-flip-box-container flip-box active">
            <a className="flip-box-inner" href={getProductCatUrl(getLinkParams(data.link))}>
              <div className="flip-box-front"  style={{borderRadius: '30px', backgroundColor: data.bgSlideColor || ''}}>
                <img
                  height="201"
                  src={process.env.PUBLIC_URL + data.image}
                  alt=""
                  style={{borderRadius: '30px', backgroundColor: data.bgSlideColor || ''}}
                  className="antera-category-slider-image"
                />
              </div>
              <div className="flip-box-back"  style={{borderRadius: '30px', backgroundColor: !!!data.animationImg ? (data.bgSlideColor ?? '') : ''}}>
                {!!data?.animationImg && 
                  <img
                    height="201"
                    src={process.env.PUBLIC_URL + data?.animationImg}
                    alt=""
                    style={{ borderRadius: '30px', backgroundColor: data.bgSlideColor || '' }}
                    className="antera-category-slider-animation-image"
                  />
                }
                <div className="backContent">
                  <p dangerouslySetInnerHTML={{ __html: data.catAnimationText }}></p>
                </div>
              </div>
            </a>
          </div> 
          :
          <div className="antera-category-slider-flip-box-container flip-box">
            <a className="flip-box-inner" href={getProductCatUrl(getLinkParams(data.link))}>
              <div className="flip-box-front" style={{borderRadius: '30px'}}>
                <img
                  height="201"
                  src={process.env.PUBLIC_URL + data.image}
                  alt=""
                  style={{borderRadius: '30px' , backgroundColor: data.bgSlideColor || ''}}
                  className="antera-category-slider-image"
                />
              </div>
            </a>
          </div>
      }
      
      
      <div className="antera-category-slider-content-container collection-content text-center">
        <a href={getProductCatUrl(getLinkParams(data.link))} >
          <h4 dangerouslySetInnerHTML={{ __html: data.title }} ></h4>
        </a>
        <h4 dangerouslySetInnerHTML={{ __html: data.subTitle }} ></h4>
        {data.btnText && (
          <Link
            to={process.env.PUBLIC_URL + data.link}
            className="collection-btn"
            style={btnStyle}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = data.btnHoverColor
              e.target.style.color = data.btnHoverTextColor
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = data.btnColor
              e.target.style.color = data.btnTextColor
            }}
            dangerouslySetInnerHTML={{ __html: data.btnText }}
          >
          </Link>
        )}
      </div>
    </div>
  );
};

CategoryFourSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string
};

export default CategoryFourSingle;
